import { Chart } from '@src/shared/ui/components/Chart';
import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { isEmpty, orderBy } from 'lodash';
import React, { useMemo } from 'react';

/**
 * Widget: UntrustedSourceRecords
 *
 * Displays the number of untrusted records by source that are with or without an action path.
 *
 * @param data
 * @returns {Element}
 * @constructor
 */
export function UntrustedSourceRecords({ data = {} }) {
  const untrustedSourceStats = data?.GetRiskDashboardStatistics?.data?.untrustedSourceStats;

  /**
   * Process the data and set the labels, red totals, and yellow totals.
   */
  const chartData = useMemo(() => {
    const theData = {
      dataSets: [],
      labels: [],
    };

    const theLabels = [];
    const actionPathTotals = [];
    const noActionPathTotals = [];

    if (!isEmpty(untrustedSourceStats)) {
      const items = orderBy(untrustedSourceStats, ['untrustedSource'], ['asc']);

      items?.forEach((item) => {
        if (!theLabels.includes(item?.untrustedSource)) {
          theLabels.push(item?.untrustedSource);
        }

        if (!actionPathTotals.includes(item?.countActiveActionPath)) {
          actionPathTotals.push(item?.countActiveActionPath);
        } else {
          actionPathTotals.push(0);
        }

        if (!noActionPathTotals.includes(item?.countNoActiveActionPath)) {
          noActionPathTotals.push(item?.countNoActiveActionPath);
        } else {
          noActionPathTotals.push(0);
        }
      });
    }

    theData.labels = theLabels;

    if (!isEmpty(actionPathTotals)) {
      theData.dataSets[0] = {
        backgroundColor: 'rgba(111, 193, 177, 0.75)',
        borderColor: 'rgba(0, 124, 137, 1.0)',
        borderWidth: 1,
        data: actionPathTotals,
        grouped: false,
        hoverBackgroundColor: 'rgba(0, 124, 137, 1.0)',
        hoverBorderColor: 'rgba(0, 124, 137, 1.0)',
        label: 'Action Path',
      };
    }

    if (!isEmpty(noActionPathTotals)) {
      theData.dataSets[1] = {
        backgroundColor: 'rgba(128, 97, 188, 0.75)',
        borderColor: 'rgba(66, 44, 136, 1.0)',
        borderWidth: 1,
        data: noActionPathTotals,
        grouped: false,
        hoverBackgroundColor: 'rgba(66, 44, 136, 1.0)',
        hoverBorderColor: 'rgba(66, 44, 136, 1.0)',
        label: 'No Action Path',
      };
    }

    return theData;
  }, [untrustedSourceStats]);

  return (
    <ErrorHandler location="src/widgets/RiskRecords/UntrustedSourceRecords/UntrustedSourceRecords.jsx">
      <Chart
        dataSets={chartData?.dataSets}
        labels={chartData?.labels}
        legendLimit={15}
        tableConfiguration={{}}
        type="HORIZONTAL_BAR_CHART"
      />
    </ErrorHandler>
  );
}
